module.exports = __webpack_public_path__ + "static/media/sap-concur-logo.4ef1fb14.svg";